import { Link } from 'react-router-dom';
import { PageSeo } from './PageSeo';
import { NarrowPage, PageHeader } from './SiteChrome';
import { SiteFooter } from './SiteFooter';
import { PAGE_META } from '../lib/seo';

export function NotFoundPage() {
  return (
    <NarrowPage>
    <div className="relative pb-8">
      <PageSeo meta={PAGE_META.notFound} />
      <PageHeader />

      <div className="text-[11px] font-black uppercase tracking-[0.25em] text-foreground/40 mb-3">
        404
      </div>
      <h1 className="text-4xl md:text-5xl font-black tracking-tight leading-none mb-6">
        Page not found
      </h1>
      <div className="h-1.5 w-24 rounded-full bg-[linear-gradient(to_right,#fb923c,#facc15,#4ade80,#22d3ee)] mb-8" />

      <p className="text-[15px] leading-relaxed text-foreground/75 mb-8 max-w-md">
        That URL does not exist on Centumth. The daily game is still here — you can play today’s
        topic, browse the archive, or read how the game works.
      </p>

      <div className="flex flex-col sm:flex-row gap-3">
        <Link
          to="/play"
          className="inline-flex items-center justify-center bg-foreground text-background px-5 py-3 rounded-2xl font-bold hover:opacity-90 transition-opacity"
        >
          Play today’s game
        </Link>
        <Link
          to="/"
          className="inline-flex items-center justify-center border border-border px-5 py-3 rounded-2xl font-bold hover:bg-muted transition-colors"
        >
          Back to home
        </Link>
      </div>

      <SiteFooter />
    </div>
    </NarrowPage>
  );
}
